import { css, Stack, Typography } from '@mui/material'
import ArrowTrendUp from 'assets/icons/nucleo/18px_arrow-trend-up.svg'
import Ticket from 'assets/icons/nucleo/18px_ticket-2.svg'
import { StyledLinkWithoutDecoration } from 'components/Checkout/CheckoutLayoutContainer'
import { useEventCardDisplayedDate } from 'components/Hook/useEventCardDistplayedDate'
import { unifiedColors } from 'styles/colors'
import { AutocompleteResultRow } from './AutocompleteResultRow'
import { EventType } from './TypeTabContent'

interface EventTypeProps {
  item: EventType
  raceSearch: string | undefined
  close: (() => void) | undefined
}

export const EventLink = ({ item, raceSearch, close }: EventTypeProps) => {
  const { dateDisplayText } = useEventCardDisplayedDate(item)

  return (
    <StyledLinkWithoutDecoration
      href={`/event/${item.eventSlug}`}
      passHref
      onClick={close}
      key={item.objectID}
    >
      <AutocompleteResultRow
        background={!!raceSearch ? 'blue50' : 'purple50'}
        iconBackground={!!raceSearch ? 'blue' : 'purple'}
        Icon={() =>
          !!raceSearch ? (
            <Ticket
              css={css`
                min-width: 18px;
                path {
                  stroke: ${unifiedColors.label.onBlue};
                }
              `}
            />
          ) : (
            <ArrowTrendUp
              css={css`
                path {
                  fill: ${unifiedColors.label.onPurple};
                }
              `}
            />
          )
        }
        value={
          <Stack>
            <Typography
              variant="body2"
              fontSize={16}
              color={unifiedColors.label.subdued}
              css={css`
                strong {
                  color: ${unifiedColors.label.default};
                }
              `}
              dangerouslySetInnerHTML={{
                __html: item._highlightResult?.eventName.value || item.eventName
              }}
            />
            {item.eventCity && (
              <Typography
                variant="body2"
                fontSize={14}
                color={unifiedColors.label.subduedDark}
              >
                {dateDisplayText}
                {'・'}
                {item.eventCity} (
                {item.eventCountrySubdivisionDisplayCodeLevel2})
              </Typography>
            )}
          </Stack>
        }
      />
    </StyledLinkWithoutDecoration>
  )
}
